<template>
  <header
    class="flex flex-row justify-between items-center px-6 sm:px-9 py-4 h-28 bg-white"
  >
    <!-- Logo (hidden on mobile) -->
    <router-link to="/">
      <!-- Desktop / Laptop / Tablet -->
      <img
        class="hidden sm:block h-12 sm:h-auto w-48 sm:w-96 object-contain"
        :src="require('@/assets/IMF-header.png')"
        alt="IMF Logo"
      />

      <!-- Mobile -->
      <img
        class="block sm:hidden h-16 object-contain"
        :src="require('@/assets/IMF.svg')"
        alt="IMF Logo"
      />
    </router-link>

    <!-- Get Started Button -->
    <span class="ml-auto">
      <router-link
        to="/portal/login"
        class="inline-block px-6 py-3 bg-primary text-white font-semibold rounded-xl shadow-md hover:bg-hover hover:shadow-lg transition duration-300"
      >
        Get Started
      </router-link>
    </span>
  </header>
</template>
